import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";
import { parseEstimate } from "features/subscriptions/utils";

export default function useSubscriptionCoupon(
  subscriptionId: string | false,
  isCustomer: boolean,
) {
  const { estimateRenewal } = useEstimateRenewal(
    isCustomer ? undefined : subscriptionId || undefined,
  );

  let subscriptionCoupon: ReturnType<typeof parseEstimate>["coupon"];
  if (estimateRenewal) {
    const { coupon } = parseEstimate(
      estimateRenewal.invoice_estimate || estimateRenewal.next_invoice_estimate,
    );
    subscriptionCoupon = coupon;
  }

  return { subscriptionCoupon };
}
